import React from "react";

class NoMatch extends React.Component {

    render() {
        return (

            <div className="text-center">
              <h1>The page you are looking for is not here.</h1>
            </div>

        )
    }
}

export default NoMatch;
